import { useRouter } from "@/hooks/useSchoolRouter";
import { trackUpgradeIntent } from "@/lib/analytics/posthog-helpers";
import { buildTrackedPaywallUrl } from "@/lib/paywallUrl";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { usePostHog } from "posthog-js/react";

interface UpgradeButtonProps {
  user: { id: string; email?: string } | null;
  subscribed: boolean;
  variant?: "default" | "zen";
  brandVariant?: "default" | "ecole" | "liceo";
}

export function UpgradeButton({
  user,
  subscribed,
  variant = "default",
  brandVariant = "default",
}: UpgradeButtonProps) {
  const posthog = usePostHog();
  const router = useRouter();

  if (!user || subscribed) {
    return null;
  }

  const handleUpgradeClick = () => {
    trackUpgradeIntent(posthog, "top_nav_upgrade_button", {
      user_id: user.id,
      email: user.email,
    });

    router.push(
      buildTrackedPaywallUrl({
        mode: variant === "zen" ? "zen" : undefined,
        source: "top_nav_upgrade_button",
      })
    );
  };

  return (
    <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
      <button
        type="button"
        onClick={handleUpgradeClick}
        className={`inline-flex h-10 items-center gap-2 rounded-lg border px-3 text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 ${
          variant === "zen"
            ? "border-stone-600/40 bg-stone-800/50 text-stone-200 hover:border-stone-500/60 hover:bg-stone-700/60 focus-visible:ring-stone-400"
            : brandVariant !== "default"
              ? "border-school-accent/70 bg-school-accent text-school-on-accent hover:bg-school-accent-bright focus-visible:ring-school-focus"
              : "border-[#FD954F]/70 bg-[#FD954F] text-[#1C1C1E] hover:bg-[#F28747] focus-visible:ring-[#FD954F]"
        }`}
      >
        <Zap className="h-4 w-4" aria-hidden="true" />
        <span className="hidden sm:inline">Upgrade</span>
      </button>
    </motion.div>
  );
}
